import {getLinkPath} from 'app/utils/link_helper';
import {isHiddenTemple} from 'app/utils/articles/isHiddenTemple';
import {ARTICLE_PROMOTION_ARCHIVE_TYPE} from 'app/utils/Consts';

export const urlName = function(type: string): string {
    if (type === ARTICLE_PROMOTION_ARCHIVE_TYPE) {
        return getLinkPath('/promotions/archive');
    }
    if (isHiddenTemple(type)) {
        return getLinkPath(`/news/${type}`);
    }
    return getLinkPath(`/${type}`);
};
